export default __webpack_public_path__ + "images/universe-master.svg";